import Oidc from 'oidc-client'

var mgr = new Oidc.UserManager({
    userStore: new Oidc.WebStorageStateStore({ store: window.localStorage }),
    authority: process.env.VUE_APP_AUTHENTICATION_URI,
    client_id: 'portal2',
    redirect_uri: process.env.VUE_APP_PORTAL_URI + '/callback.html',
    response_type: 'id_token token',
    scope: 'openid profile portal authService diceService licenseActivationService contentService crmService notificationService offline_access',
    post_logout_redirect_uri: process.env.VUE_APP_PORTAL_URI + '/',
    silent_redirect_uri: process.env.VUE_APP_PORTAL_URI+'/silent-renew.html',
    accessTokenExpiringNotificationTime: 10,
    automaticSilentRenew: true,
    filterProtocolClaims: true,
    loadUserInfo: true
})

Oidc.Log.logger = console
Oidc.Log.level = Oidc.Log.NONE

mgr.events.addUserLoaded(function (user) {
})

mgr.events.addAccessTokenExpiring(function () {
})

mgr.events.addAccessTokenExpired(function () {
    //alert('Session expired. Going out!')
    mgr.signoutRedirect().then(function (resp) {
    }).catch(function (err) {
        console.log(err)
    })
})

mgr.events.addSilentRenewError(function () {
    console.error('Silent Renew Error：', arguments)
})

mgr.events.addUserSignedOut(function () {
    //alert('Going out!')
    //mgr.removeUser()
    mgr.signoutRedirect().then(function (resp) {
    }).catch(function (err) {
        console.log(err)
    })
})

export default class SecurityService {

    getUser() {
        let self = this
        return new Promise((resolve, reject) => {
            mgr.getUser().then(function (user) {
                if (user == null) {
                    self.signIn()
                    return resolve(null)
                } else {
                    return resolve(user)
                }
            }).catch(function (err) {
                console.log(err)
                return reject(err)
            })
        })
    }
    getSignedIn() {
        let self = this
        return new Promise((resolve, reject) => {
            mgr.getUser().then(function (user) {
                if (user == null) {
                    self.signIn()
                    return resolve(false)
                } else {
                    return resolve(true)
                }
            }).catch(function (err) {
                console.log(err)
                return reject(err)
            })
        })
    }
    signIn() {
        mgr.signinRedirect().catch(function (err) {
            console.log(err)
        })
    }
    signOut() {
        localStorage.removeItem("org")
        localStorage.removeItem("organizations")
        localStorage.removeItem("openOrders")
        localStorage.removeItem("completedOrders")
        localStorage.removeItem("createdDevices")
        localStorage.removeItem("warranties")
        localStorage.removeItem("devices")
        var self = this
        mgr.signoutRedirect().then(function (resp) {
        }).catch(function (err) {
            console.log(err)
        })
    }

    getToken() {
        let self = this
        return new Promise((resolve, reject) => {
            mgr.getUser().then(function (user) {
                if (user == null) {
                    self.signIn()
                    return resolve(false)
                } else {
                    return resolve(user)
                }
            }).catch(function (err) {
                console.log(err)
                return reject(err)
            })
        })
    }

    getProfile() {
        let self = this
        return new Promise((resolve, reject) => {
            mgr.getUser().then(function (user) {
                if (user == null) {
                    self.signIn()
                    return resolve(false)
                } else {
                    return resolve(user.profile)
                }
            }).catch(function (err) {
                console.log(err)
                return reject(err)
            })
        })
    }

    getIdToken() {
        let self = this
        return new Promise((resolve, reject) => {
            mgr.getUser().then(function (user) {
                if (user == null) {
                    self.signIn()
                    return resolve(false)
                } else {
                    return resolve(user.id_token)
                }
            }).catch(function (err) {
                console.log(err)
                return reject(err)
            })
        })
    }

    getSessionState() {
        let self = this
        return new Promise((resolve, reject) => {
            mgr.getUser().then(function (user) {
                if (user == null) {
                    self.signIn()
                    return resolve(false)
                } else {
                    return resolve(user.session_state)
                }
            }).catch(function (err) {
                console.log(err)
                return reject(err)
            })
        })
    }

    getAcessToken() {
        let self = this
        return new Promise((resolve, reject) => {
            mgr.getUser().then(function (user) {
                if (user == null) {
                    self.signIn()
                    return resolve(false)
                } else {
                    return resolve(user.access_token)
                }
            }).catch(function (err) {
                console.log(err)
                return reject(err)
            })
        })
    }

    getScopes() {
        let self = this
        return new Promise((resolve, reject) => {
            mgr.getUser().then(function (user) {
                if (user == null) {
                    self.signIn()
                    return resolve(false)
                } else {
                    return resolve(user.scopes)
                }
            }).catch(function (err) {
                console.log(err)
                return reject(err)
            })
        })
    }

    getRole() {
        let self = this
        return new Promise((resolve, reject) => {
            mgr.getUser().then(function (user) {
                if (user == null) {
                    //self.signIn()
                    return resolve(false)
                } else {
                    return resolve(user.profile.role)
                }
            }).catch(function (err) {
                console.log(err)
                return reject(err)
            })
        })
    }
}